export default __webpack_public_path__ + "static/media/welfare-special.f5af87fa.png";